export default "__VITE_ASSET__dfweVcYM__"